import { useState } from "react";
import { useTranslation } from "react-i18next";
import NewsEmptyContainer from "src/components/common/news-empty-container";
import ApplicationRequestsForSchoolsContainer from "./application-requests-for-schools-container/application-requests-for-schools-container";
import SchoolOffersContainer from "./school-offers-container/school-offers-container";

function SchoolProfileList() {
  const { i18n, t } = useTranslation();

  const list = [
    {
      title: t("schoolProfileList.container.news"),
      component: <NewsEmptyContainer />,
    },
    {
      title: t("schoolProfileList.container.applyRequests"),
      component: <ApplicationRequestsForSchoolsContainer />,
    },
    {
      title: t("schoolProfileList.container.offers"),
      component: <SchoolOffersContainer />,
    },
  ];
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [componnent, setCurrentComponent] = useState(<NewsEmptyContainer />);

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col mt-8 mobile:gap-0 mobile:px-3"
    >
      <div className="text-center">
        <div className="flex flex-row gap-6 mobile:gap-0 items-start h-[44px] mobile:h-[64px] content-start justify-start mobile:justify-between">
          {list.map((item, index) => {
            return (
              <div
              key={index}
                className={`flex ${
                  index > 0 ? "mr-4" : "mr-0"
                } font-ar text-base`}
              >
                <div
                  className={`${
                    index === currentIndex
                      ? "text-white bg-mint-500"
                      : "text-[#435363] border border-[#EAEEF4] bg-white"
                  } flex items-center justify-center px-6 rounded-full w-auto min-w-[93px] h-[44px] mobile:text-sm cursor-pointer`}
                  onClick={() => {
                    setCurrentIndex(index);
                    setCurrentComponent(item.component);
                  }}
                >
                  {item.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {componnent}
    </div>
  );
}

export default SchoolProfileList;
